import fetch from './index'

export function getPowers(): any {
  return fetch.get('/auths/values')
}
// 获取权限树